/**
 * @author Muhammad Hamza
 * @datetime 28, 01 2023
 * @description: This directive is for control access rights throughout the application where LoggedIn
 *               user will be enabled or disabled the rights for accessing other users accounts on the
 *               of thier access right based on thier user type.
 */
import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { UserRightsAccessControl } from 'src/app/shared/utils/user-access-rights';
import { removeSpecialChar } from 'src/app/shared/utils/utility.service';

@Directive({
  selector: '[accessRight]',
})
export class AccessRightDirective {
  @Output() access: EventEmitter<boolean> = new EventEmitter<boolean>();
  currentUserRole: string = this.helperService.getUserRole;

  constructor(
    private helperService: HelperService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    renderer.addClass(el.nativeElement, 'access-right-directive');
  }

  /* @param data { any[] }  this array contains three parameters i.e [ userType, action, ownProfile ]
   * where userType can be: 'PropertyManagerAdmin' | 'PropertyManagerUser' | InstallerAdmin | InstallerUser | EndUser
   * where action can be:  create | update | view | delete
   * where ownProfile can be : true | false
   */
  @Input() set accessRight(data: any[]) {
    const userType: string = removeSpecialChar(data[0]);
    const action: string = data[1];
    const ownProfile: boolean = data[2];

    if (ownProfile) {
      this.access.emit(false);
    } else {
      let selectedUserAccessRights: any;

      selectedUserAccessRights = UserRightsAccessControl.find((access: any) => {
        if (access.roleName === this.currentUserRole) {
          return access.users;
        }
      })?.users.find((user: any) => {
        if (user.name === userType) {
          return user;
        }
      });
      let { [action]: accessAllowed } = selectedUserAccessRights;
      if (!accessAllowed) {
        this.access.emit(true);
        this.el.nativeElement.disabled = true;
      } else {
        this.el.nativeElement.disabled = false;
        this.access.emit(false);
      }
    }
  }
}
